<template>
	<div :class="['job-vita--section', 'job-vita--grid']">
		<div class="job-vita--section-title">
			<div :class="['job-vita--section-title-icon', {'job-vita--section-title-icon-full-match': isFullMatch}]">
				<Icon
					:icon="isFullMatch ? 'checkmark' : 'tilde'"
					color="white"
				/>
			</div>
			<div>{{ grid.title }}</div>
		</div>
		<div class="job-vita--grid-areas">
			<Area
				v-for="area in grid.areas"
				:key="area.id"
				:area="area"
				:job-profile-id="jobProfileId"
				:pseudonym-id="pseudonymId"
				@upgrade="$emit('upgrade')"
			/>
		</div>
	</div>
</template>

<script>
import Area from "./grid/Area";
import Icon from "@/vue/icon/Icon";
import Matching from "./grid/Matching"

export default {

	components: {
		Area,
		Icon,
		Matching,
	},

	props: {
		jobProfileId: {
			type: String,
			required: true,
		},
		pseudonymId: {
			type: String,
			required: false,
		},
		grid: {
			type: Object,
			required: true,
		}
	},

	computed: {
		isFullMatch ()
		{
			return this.grid.fullMatch;
		}
	}
}
</script>
